import React, { useState } from "react";
// import {LogoImage} from '../assets';
import { Col, Container, Form, Row, Button } from "react-bootstrap";
import Calendar from "react-calendar";
import { useNavigate } from "react-router-dom";
import Loading from "./Loading";
import "react-calendar/dist/Calendar.css";
import moment from "moment";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// import DatePicker from 'react-datepicker'
// import 'react-datepicker/dist/react-datepicker.css'

const firebaseConfig = {
  apiKey: "AIzaSyALsBFKOx-kYOLIO_J6sYQV4fE4Fs-FwSs",
  authDomain: "medical-elhall.firebaseapp.com",
  databaseURL: "https://medical-elhall-default-rtdb.firebaseio.com",
  projectId: "medical-elhall",
  storageBucket: "medical-elhall.appspot.com",
  messagingSenderId: "23715070738",
  appId: "1:23715070738:web:522f8c5e633f1e54a029cb",
  measurementId: "G-VLPGEDG18N",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

function PatiantLog() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [showloading, setShowloading] = useState(false);
  const navigate = useNavigate();
  const [error, setError] = useState({});
  getAnalytics(app);

  async function Log() {
    if (
      error.email ||
      error.date ||
      error.dateOfBirth ||
      error.firstName ||
      error.lastName ||
      error.time ||
      error.lastName
    ) {
      alert("برجاء ادخال البيانات ");
      navigate("/patiantlog");
    } else {
      setShowloading(true);
      //   let datee  = moment(date).toISOString(true);
      //  setDate(datee)
      date.setDate(date.getDate() + 1);
      let item = { firstName, lastName, date, email, time, dateOfBirth, phone };
      console.warn(item);

      let result = await fetch(
        "https://clincapi.azurewebsites.net/api/1.0/Visits/RegisterUserAndVisit",
        {
          method: "POST",
          body: JSON.stringify(item),
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      result = await result.json();
      console.warn("result", result);
      navigate("/waiting");
      setShowloading(false);
    }
  }

  const onChangeCal = (daty) => {
    setDate(daty);
    console.log("setDate", daty);
    console.log("setDate final", date);
  };

  if (!email) {
    error.email = "يرجى كتابة البريد الالكتروني";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(email)) {
    error.email = "ُ البريد الالكتروني غير صحيح";
  } else {
    error.email = "";
  }
  if (!phone) {
    error.phone = "يرجى كتابة رقم الهاتف";
  } else {
    error.phone = "";
  }
  if (!firstName) {
    error.firstName = "يرجى كتابة الاسم الاول";
  } else {
    error.firstName = "";
  }
  if (!lastName) {
    error.lastName = "يرجى كتابة اللقب  ";
  } else {
    error.lastName = "";
  }
  if (!date) {
    error.date = "يرجى اختيار يوم زيارتك ";
  } else {
    error.date = "";
  }
  if (!time) {
    error.time = "يرجى اختيار ميعاد زيارتك ";
  } else {
    error.time = "";
  }
  if (!dateOfBirth) {
    error.dateOfBirth = "يرجى كتابة تاريخ الميلاد ";
  } else {
    error.dateOfBirth = "";
  }

  return (
    <>
      <br />

      <Container style={{ textAlign: "right" }}>
        <p className="doctor">
          دكتور{" "}
          <span style={{ fontSize: "35px", fontWeight: "800" }}>
            / علي الحال
          </span>
        </p>
        <p className="fonts" style={{ fontSize: "20px", fontWeight: "800" }}>
          باطني - صدرية - حميات
        </p>
        <p className="fonts" style={{ fontSize: "20px", fontWeight: "800" }}>
          {" "}
          رئيس اقسام الطواريء والرعاية بدولة قطر (سابقاً)
        </p>
        <div className="sliderr"></div>
        <br />
      </Container>
      <br />
      <div
        style={{
          borderColor: "#43425D",
          borderStyle: "solid",
          borderRadius: "25px",
          paddingRight: "10%",
          paddingLeft: "10%",
          marginRight: "10%",
          marginLeft: "10%",
        }}
      >
        <h1 className="fonts" style={{ fontWeight: "bold", color: "#43425D" }}>
          كشف منزلي
        </h1>
        <hr />

        {/* <Col lg={5} md={4} xs={12}>
        <a className='what' href="https://wa.link/6hmak7"></a>
        </Col> */}
        <Col lg={12} md={12} xs={12} style={{ textAlign: "center" }}>
          <a href="tel:01110115999" className="call">
            <span style={{ fontSize: "25px" }}>
              <b>✆</b>
            </span>{" "}
            0111 0115 999{" "}
          </a>

          <a className="whatsapp" href="https://wa.link/6hmak7">
            WhatsApp
          </a>
        </Col>
        {/* <Row>
          <Col lg={6} md={4} xs={1} style={{textAlign:"center"}} className="whataa">
           <a className='whatsapp' href="https://wa.link/6hmak7">WhatsApp</a>
         </Col>
         <Col lg={6} md={4} xs={10} style={{textAlign:"center"}}>
         <a href="tel:01110115999" className="call" >
              <span style={{ fontSize: "25px"  }}>
                <b>✆</b>
              </span>
              {" "}{" "}0111 0115 999{" "}
            </a>
        </Col>
          </Row> */}
        {/* <a href="tel:01110115999" className="call">
              <span style={{ fontSize: "25px" , paddingTop:"10px" }}>
                <b>✆</b>
              </span>
              {" "}{" "}0111 0115 999{" "}
            </a> */}

        {/* <Col lg={4} md={4} xs={12}>
        <a className='whatsapp' href="https://wa.link/zik1kq"> 011-55-11-08-01 / whatsapp </a>
        </Col> */}

        <br />
      </div>
      <br />
      <br />
      {showloading && <Loading />}
      <Container className="fonts" style={{ width: "55%", color: "#43425D" }}>
        <h1 style={{ fontWeight: "bold" }}>كشف العيادة</h1>
        <h1 className=" mt-1 text-center rounded b" style={{ fontSize: "48" }}>
          احجز ميعادك اونلاين
        </h1>
        {/* <br /> */}
        <div className="slider"></div>
        <h4 className=" mt-2 text-center b" style={{ fontSize: "48" }}>
          املأ بياناتك الان وسنقوم بالاتصال بك لتأكيد الحجز
        </h4>
        <br />

        <Row className="mt-3 mr-20 ml-20 ">
          <Col lg={6} md={6} sm={12} className=" ml-auto mr-auto rounded-lg">
            <Form className="rb">
              <Form.Group className="mb-3 rb" controlId="formBasicLname ">
                <Form.Control
                  style={{ color: "#43425D" }}
                  className="text-right "
                  type="text"
                  placeholder=" اسم العائلة أو اللقب"
                  value={lastName}
                  required
                  onChange={(e) => setLastName(e.target.value)}
                />
                {error.lastName && <p className="error2">{error.lastName}</p>}
              </Form.Group>
            </Form>
          </Col>
          <Col lg={6} md={6} sm={12} className=" ml-auto mr-auto rounded-lg ">
            <Form className="ra">
              <Form.Group
                className="mb-3 text-right ra"
                controlId="formBasicEmail"
              >
                <Form.Control
                  className="text-right "
                  type="email"
                  placeholder="الاسم الاول"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />
                {error.firstName && <p className="error">{error.firstName}</p>}
              </Form.Group>
            </Form>
          </Col>
          <Col lg={6} md={6} sm={12} className=" ml-auto mr-auto rounded-lg">
            <Form className="rc">
              <Form.Group className="mb-3 rc" controlId="formBasicFname">
                <Form.Control
                  className="text-right "
                  type="text"
                  placeholder="البريد الالكتروني"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                {error.email && <p className="error2">{error.email}</p>}
              </Form.Group>
            </Form>
          </Col>
          <Col lg={6} md={6} sm={12} className=" ml-auto mr-auto rounded-lg">
            <Form className="rd">
              <Form.Group className="mb-3 rd" controlId="formBasicPassword">
                <Form.Control
                  className="text-right "
                  type="text"
                  placeholder="رقم الهاتف"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
                {error.phone && <p className="error2">{error.phone}</p>}
              </Form.Group>
            </Form>
          </Col>
          <Col lg={6} md={6} sm={12} className=" ml-auto mr-auto rounded-lg">
            <Form>
              <Form.Select
                aria-label="Default select example"
                className="text-right"
                value={time}
                onChange={(e) => setTime(e.target.value)}
              >
                <option dir="rtl">الوقت</option>
                <option> 13:00:00 </option>
                <option> 14:00:00 </option>
                <option> 15:00:00 </option>
                <option> 16:00:00 </option>
                <option> 17:00:00 </option>
                <option> 18:00:00 </option>
                <option> 19:00:00 </option>
                <option> 20:00:00 </option>
                <option> 21:00:00 </option>
              </Form.Select>
              {error.time && <p className="error2">{error.time}</p>}
            </Form>
          </Col>
          <Col lg={3} md={3} sm={12} className=" ml-auto mr-auto rounded-lg">
            <div>
              <input
                type="date"
                className="date"
                min="1980-01-01"
                max="2030-12-31"
                onChange={(e) => setDateOfBirth(e.target.value)}
              />
              {error.dateOfBirth && (
                <p className="error2">{error.dateOfBirth}</p>
              )}
            </div>
          </Col>
          <Col lg={3} md={3} sm={12}>
            <p className="par">ادخل تاريخ الميلاد</p>
          </Col>
          <br /> <br />
          {/* <br /> <br /> */}
          <p className="par2">{date.toString()} اختر يوم زيارتك </p>
          {error.date && <p className="error">{error.date}</p>}
          <Calendar
            onChange={onChangeCal}
            value={date}
            // dateFormat="dd/MM/yyyy"
            minDate={new Date()}
          />
          {console.log(date)}
          <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br />
          {/* <br /> <br /> <br /> */}
          <Button
            className=" btn-block mo ml-auto mr-auto  "
            type="submit"
            onClick={Log}
          >
            إرســـال
          </Button>
        </Row>
      </Container>

      <br />
      <div className="footer">
        <p style={{ fontSize: "19px" }}>
          {" "}
          ٦١٢ طريق الحرية (شارع أبو قير) - زيزينيا - برج الاطباء - الدور الاول{" "}
        </p>
        <Row>
          <Col lg={4} md={4} xs={10} className="mt-auto mb-auto">
            <a href="tel:01110115999" className="callf">
              <span style={{ fontSize: "20px" }}>
                <b>✆</b>
              </span>{" "}
              0111 0115 999{" "}
            </a>
          </Col>
          <Col lg={4} md={4} xs={10} className="mt-auto mb-auto">
            <a href="tel:01155110801" className="callf">
              <span style={{ fontSize: "20px" }}>
                <b>✆</b>
              </span>{" "}
              011 5511 0801{" "}
            </a>
          </Col>
          <Col lg={4} md={4} xs={10}>
            <a className="wha" href="https://wa.link/6hmak7">
              {" "}
            </a>
          </Col>
        </Row>

        <p> مواعيد العمل من ٠٥,٣٠ م الى ١٠,٠٠ م </p>
      </div>
    </>
  );
}

export default PatiantLog;
